import * as React from 'react'
import * as R from 'ramda'
import { Link } from 'react-router-dom'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import { Store } from '../../../../reducers/index'
import { Action } from '../../../../actions/types'
import { clearJobId } from '../../../../actions/calculation'

import BeamProfile from '../../../Results/BeamProfile'
import styled, { keyframes } from '../../../../theme/styled'
import { Button } from '../../../Styled/Shared'
import {
  getProjectId,
  getActiveCase,
  EditableCase
} from '../../../../reducers/project'
import { JobResult } from '../../../ResultData/resultDataQuery'
import { LoadingBlock } from '../../../Shared/LoadIndicators'

const pulseOpacity = keyframes`
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
`

const SneakWindowItem = styled.div`
  width: 170px;
  height: 170px;
  background: ${({ theme }) => theme.colors.invert};
  border-radius: 9px;
  margin: 10px 10px 15px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  float: left;

  &:hover {
    border: 2px solid ${({ theme }) => theme.colors.brand};
  }

  /* BeamProfile uses canvas and we don't want the spinner's alignment to be off */
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex: 1 0 auto;
  }

  img {
    max-width: 150px;
  }

  img.loader {
    max-width: 75px;
    animation: ${pulseOpacity} 3s infinite;
  }
`

const ErrorPanel = styled.div`
  color: ${({ theme }) => theme.colors.inactive};
  text-align: center;

  margin-top: 20px;
  margin-bottom: 50px;
`

const SneakWin = styled.div`
  position: absolute;
  bottom: 50px;
  right: 0;
  width: 590px;

  white-space: nowrap;

  height: 250px;
  background: #354b55;
  border-radius: 18px;

  padding: 0 10px;

  .button-container {
    clear: both;
    text-align: center;
  }
`

type Props = {
  jobId?: string
  projectId: string
  case: EditableCase | undefined
  clearJob: () => Action
  resultCount: number
  results: JobResult[]
  error?: string | null
}

export class SneakWindow extends React.Component<Props> {
  render() {
    const {
      resultCount,
      clearJob,
      results,
      projectId,
      jobId,
      error,
      case: kase
    } = this.props

    if (error) {
      return (
        <SneakWin>
          <ErrorPanel>{error}</ErrorPanel>
          <div className="button-container">
            <Button onClick={() => clearJob()}>Cancel</Button>
          </div>
        </SneakWin>
      )
    }

    const numResults = results.length
    const emptyResultCount = resultCount - numResults

    const incomplete = R.times(
      i => (
        <SneakWindowItem key={i}>
          <img className="loader" src={LoadingBlock} alt="Loading" />
          <br />
          Calculating...
        </SneakWindowItem>
      ),
      emptyResultCount >= 0 ? emptyResultCount : 0
    )

    const widest = Math.max(...R.pluck<number>('beamWidth', results)) + 100 // Add room for dimensions

    return (
      <SneakWin>
        {results.map(res => (
          <SneakWindowItem key={res.id}>
            <Link
              to={`/project/${projectId}/case/${kase!.id}/results/${jobId}/${
                res.id
              }`}
            >
              <BeamProfile requestWidth={widest} beamType={res.beamType} />
            </Link>
          </SneakWindowItem>
        ))}
        {incomplete}

        <div className="button-container">
          <Button onClick={() => clearJob()}>Cancel</Button>
        </div>
      </SneakWin>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  projectId: getProjectId(state),
  case: getActiveCase(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  clearJob: () => dispatch(clearJobId())
})

export default connect(mapStateToProps, mapDispatchToProps)(SneakWindow)



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/SneakWindow/index.tsx